import { CardActionLink } from '@/common/components/CardActionLink/CardActionLink';
import { IllustrationSeedling } from '@/common/components/Illustrations/IllustrationSeedling';
import { ROUTES } from '@/common/constants/routes';
import { IBenefitOptin } from '@/common/integrations/menhir/employee/benefits/benefits.types';
import { useGetOptInCardContent } from './PTOptInCard.utils';

export type PTOptInCardProps = {
  optIn: IBenefitOptin;
};

export function PTOptInCard({ optIn }: PTOptInCardProps) {
  const { title, description } = useGetOptInCardContent(optIn);

  return (
    <CardActionLink
      title={title}
      description={description}
      size="md"
      backgroundColor={
        optIn.allocatedAmount ? 'accentPrimary10' : 'accentPrimary20'
      }
      illustration={{
        asset: <IllustrationSeedling width={80} height={80} />,
      }}
      href={ROUTES.BENEFITS_OPTIN}
    />
  );
}
